module.exports = __webpack_public_path__ + "media/svg/mu-fe97046c.svg";